import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { consume } from '@lit/context'
import { activeQuotationContext } from 'components/ordering/quotation/components/context/quotation-context.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'
import { hostDisplayContents } from 'components/ordering/quotation/components/quotation.style.js'

@customElement('csc-quotation-note-merchant')
export class CSCQuotationNoteMerchant extends LitElement {
  static override styles: CSSResultGroup = [hostDisplayContents]

  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError

  @state()
  private get isVisible(): boolean {
    return isQuotationDTO(this.quotation) && !!this.quotation.noteMerchant
  }

  override render() {
    if (!isQuotationDTO(this.quotation) || !this.isVisible) return nothing

    return html`
      <cse-paper bordered variant="primary">
        <cse-text variant="heading-5" slot="heading">
          ${t('csc_quotation_note_merchant_heading', {
            ns: 'csc-quotation-note-merchant',
            default: 'Note seller'
          })}
        </cse-text>

        ${this.quotation.noteMerchant}
      </cse-paper>
    `
  }
}
